import {
  defineNuxtPlugin,
  useNuxtApp,
} from 'nuxt/app'

import type { MissingIconEventDetail } from '@packages/icons/modules/plugins/types/missing-icon-event'

export default defineNuxtPlugin(() => {
  const nuxtApp = useNuxtApp()
  const reportedMissingIcons = new Set<string>()

  const reportMissingIcon = ({ detail }: CustomEvent<MissingIconEventDetail>): void => {
    if (!detail.icon?.iconName) {
      return
    }

    const missingIcon = `${detail.icon.iconName} (${detail.icon.prefix})`
    if (reportedMissingIcons.has(missingIcon)) {
      return
    }

    reportedMissingIcons.add(missingIcon)
    nuxtApp.$sentryCaptureMessage(`Missing icon: ${missingIcon}`, {
      level: 'warning',
      extra: { ...detail },
    })
  }

  window.addEventListener('fontawesome:missing-icon', reportMissingIcon)
})
